module.exports = __webpack_public_path__ + "img/madness_460.c983c3b9.png";